<template>
  <div class="relative flex flex-col items-center justify-center">
    <div
      class="pointer-events-none fixed inset-0 bg-primary-tints-500 bg-linear-to-tr from-accent-tints-600"
      aria-hidden="true"
    />
    <div class="relative z-10 flex flex-col items-center justify-center">
      <wui-icon
        name="clearRing"
        class="text-primary-shades-600 w-40! h-40! mb-6"
      />
      <p class="text-5264 text-primary-shades-600 font-medium mb-8">
        {{ $t('common.error') }}!
      </p>
      <p class="mb-10 text-2024">
        {{ errorMessage }}
      </p>
      <wui-btn
        :size="48"
        variant="brand"
        state="filled"
        @click="reload"
      >
        {{ $t('common.reloadPage') }}
      </wui-btn>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { WuiIcon, WuiBtn } from '@wui/common-library'
defineProps<{
  errorMessage: string
}>()

const reload = () => document.location.reload()
</script>
